module.exports = __webpack_public_path__ + "bd01b489a817f9c75a07c43264ea3709.pdf";